import React, {Component} from 'react';
import './App.css';
import './components/styles/Header.css'
import './components/styles/Mobilka.css'
import {BrowserRouter as Router, Redirect, Route, Switch} from 'react-router-dom';
import Home from "./components/home/Home";
import Wyniki from "./components/wyszukiwarka/Wyniki";
import Finalizacja from "./components/koszyk/finalizacja/Finalizacja";
import LoginAdmin from "./components/admin/LoginAdmin";
import Wynajem from "./components/home/homeComponents/Wynajem";
import Aktualnosci from "./components/home/homeComponents/Aktualnosci";
import Header from "./components/shared/Header";
import RealizacjaTPay from "./components/koszyk/finalizacja/RealizacjaTPay";
import RealizacjaTPayFail from "./components/koszyk/finalizacja/RealizacjaTPayFail";
import strings from './components/strings/localeStrings'
import Transakcja from "./components/konto/Transakcja";
import Aktywacja from "./components/konto/Aktywacja";
import Kontakt from "./components/home/homeComponents/Kontakt";
import Strona from "./components/home/homeComponents/Strona";
import Rozklad from "./components/rozklad/Rozklad";
import MapaComponent from "./components/home/homeComponents/MapaComponent";
import ResetHasla from "./components/konto/ResetHasla";
import Regulaminy from "./components/home/homeComponents/Regulaminy";
import FirmaOnas from "./components/home/homeComponents/firmaComponents/FirmaOnas";
import Nagrody from "./components/home/homeComponents/firmaComponents/Nagrody";
import SesjaWygasla from "./components/shared/SesjaWygasla";
import Komunikat from "./components/shared/Komunikat";
import ZmianaHasla from "./components/konto/panel/panelComponents/ZmianaHasla";
import Eventy from "./components/konto/panel/panelComponents/Eventy";
import Event from "./components/konto/panel/panelComponents/eventyComponents/Event";
import DaneOsobowe from "./components/konto/panel/panelComponents/DaneOsobowe";
import BOK from "./components/konto/panel/panelComponents/BOK";
import MojeBilety from "./components/konto/panel/panelComponents/MojeBilety";
import BOKszczegoly from "./components/konto/panel/panelComponents/bokComponents/BOKszczegoly";
import BiletyJednorazowe from "./components/konto/panel/panelComponents/mojeBiletyComponents/BiletyJednorazowe";
import RealizacjaTPayMiesieczne from "./components/koszyk/finalizacja/RealizacjaTPayMiesieczne";
import RealizacjaTPayFailMiesieczne from "./components/koszyk/finalizacja/RealizacjaTPayFailMiesieczne";
import Error from './components/home/Error'
import KontoComponent from "./components/konto/kontoComponents/KontoComponent";
import PasswordLostComponent from "./components/konto/kontoComponents/PasswordLostComponent";
import RegisterComponent from "./components/konto/kontoComponents/RegisterComponent";
import AdminPanelHome from "./components/admin/adminComponents/AdminPanelHome";
import AdminAktualnosci from "./components/admin/adminComponents/AdminAktualnosci";
import AdminEventy from "./components/admin/adminComponents/AdminEventy";
import AdminGaleria from "./components/admin/adminComponents/AdminGaleria";
import AdminSlider from "./components/admin/adminComponents/AdminSlider";
import AdminStrony from "./components/admin/adminComponents/AdminStrony";
import AdminPliki from "./components/admin/adminComponents/AdminPliki";
import {NotificationContainer, NotificationManager} from 'react-notifications';
import 'react-notifications/lib/notifications.css';
import axios from "axios";
import ZwrotBiletu from "./components/home/homeComponents/ZwrotBiletu";
import Bowser from "bowser"
import BiletyMiesieczne from "./components/konto/panel/panelComponents/mojeBiletyComponents/BiletyMiesieczne";
import PomyslnieMiesieczny from "./components/konto/panel/panelComponents/mojeBiletyComponents/PomyslnieMiesieczny";
import GeneratorFaktur from "./components/koszyk/GeneratorFaktur";
import PotwierdzeniePrzejazdu from "./components/koszyk/PotwierdzeniePrzejazdu";

if (window.location.href.indexOf('site.marcel-bus.pl') > -1) {
    console.log = () => {
    };
}

axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (Boolean(error.response)) {
        if (!Boolean(error.response.data.message)) {
            NotificationManager.error('Kod błędu ' + error.response.status + ', error: ' + error.response.statusText, 'Wystąpił błąd podczas działania aplikacji', 10000);
        } else {
            if (error.response.data.message === "User is disabled") {
                NotificationManager.error("Aktywuj konto przez link zamieszczony w wysłanej wiadomości e-mail", 'Konto jest nieaktywne', 10000);
            } else {
                if (error.response.data.message === "Bad credentials") {
                    NotificationManager.error("", 'Niepoprawne dane logowania', 10000);
                } else {
                    NotificationManager.error(error.response.data.message, 'Wystąpił błąd podczas działania aplikacji', 10000);
                }
            }
        }
        return Promise.reject(error);
    } else {
        NotificationManager.error('Brak komunikacji z serwerem', 'Wystąpił błąd podczas działania aplikacji', 10000);
        return Promise.reject(error);
    }
});

class App extends Component {

    constructor(props) {
        super(props);

        let komunikat = false;

        if (localStorage.getItem('komunikat') === null || localStorage.getItem('komunikat') === undefined) {
            komunikat = true
        }

        this.state = {
            koszyk: true,
            komunikat: komunikat,
            lang: '',
            stylePath: '',
            sesjaWygasla: false
        }
    }

    // componentWillMount() {
    //     this.startErrorLog();
    // }
    //
    // startErrorLog() {
    //     window.onerror = (message, file, line, column, errorObject) => {
    //         column = column || (window.event && window.event.errorCharacter);
    //         let stack = errorObject ? errorObject.stack : null;
    //         let data = {
    //             message: message,
    //             file: file,
    //             line: line,
    //             column: column,
    //             errorStack: stack,
    //         };
    //
    //         console.log('Message: ' + message)
    //         console.log('Error stack: ' + stack)
    //         console.log("Cookies: " + navigator.cookieEnabled)
    //         console.log("Platform: " + navigator.platform)
    //         console.log(Bowser.parse(window.navigator.userAgent));
    //
    //         console.log(data);
    //
    //         //here I make a call to the server to log the error
    //
    //         //the error can still be triggered as usual, we just wanted to know what's happening on the client side
    //         return false;
    //     }
    // }

    setLang(lang) {
        this.setState({lang: lang});
        strings.setLanguage(lang)
    }

    hasNullImieNazwisko(target) {
        for (let member in target) {
            if (target['imie'] == null || target['imie'] === "") {
                return true;
            }
            if (target['nazwisko'] == null || target['nazwisko'] === "") {
                return true;
            }
        }
        return false;
    }

    hasNull(target) {
        for (let member in target) {
            if (target['imie'] == null || target['imie'] === "") {
                return true;
            }
            if (target['nazwisko'] == null || target['nazwisko'] === "") {
                return true;
            }
            // if (target['pesel'] == null || target['pesel'] === "") {
            //     return true;
            // }
            if (target['kodPoczt'] == null || target['kodPoczt'] === "") {
                return true;
            }
            if (target['ulica'] == null || target['ulica'] === "") {
                return true;
            }
            if (target['nrTel'] == null || target['nrTel'] === "") {
                return true;
            }
            if (target['miejscowosc'] == null || target['miejscowosc'] === "") {
                return true;
            }
            if (target['nrDomu'] == null || target['nrDomu'] === "") {
                return true;
            }
            if (target['pliki'] == null || target['pliki'] === "") {
                return true;
            }
            if (target['pliki'].length === 0) {
                return true;
            }
        }
        return false;
    }

    render() {
        return (
            <Router>
                <div>

                    <div>
                        {this.state.sesjaWygasla ?
                            <SesjaWygasla setSesja={() => this.setState({sesjaWygasla: false})}/> : null}
                        {this.state.stylePath ?
                            <link rel="stylesheet" type="text/css" href={this.state.stylePath}/> : null}
                        {window.location.href.indexOf('admin') <= -1 ?
                            <div>{this.state.komunikat ? <Komunikat setKomunikat={() => {
                                this.setState({komunikat: false});
                                localStorage.setItem('komunikat', true)
                            }}/> : null}
                                <Header koszyk={this.state.koszyk} lang={(lang) => this.setLang(lang)}
                                        sesjaWygasla={() => this.setState({sesjaWygasla: true})}
                                        setStyle={(style) => {
                                            this.setState({stylePath: style})
                                        }}/></div> : null}
                        <div className="fadein">
                            <Switch>
                                <Route exact path="/" component={Home}/>
                                <Route exact path="/admin"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminPanelHome/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/aktualnosci"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminAktualnosci/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/eventy"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminEventy link={2}/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/biblioteka-mediow"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminGaleria link={3}/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/slider"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminSlider link={4}/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/strony"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminStrony link={5}/> : <LoginAdmin/>}/>
                                <Route exact path="/admin/panel/pliki"
                                       render={() => (sessionStorage.getItem('adminLoggedIn') !== null) ?
                                           <AdminPliki link={6}/> : <LoginAdmin/>}/>
                                <Route exact path="/search/:mW/:mD/:data/:godzina" render={(props) => <Wyniki
                                    koszyk={() => this.setState({koszyk: !this.state.koszyk})} {...props} />}
                                       handler={Wyniki}/>
                                <Route exact path="/search/:mW/:mD/:data/:godzina/powrotny/:dataPow/:godzinaPow"
                                       render={(props) => <Wyniki
                                           koszyk={() => this.setState({koszyk: !this.state.koszyk})} {...props} />}
                                       handler={Wyniki}/>
                                <Route exact path="/koszyk" render={() => <Finalizacja
                                    koszyk={() => this.setState({koszyk: !this.state.koszyk})}/>}/>
                                <Route exact path="/koszyk/platnosc=ok&transakcja=:transakcja"
                                       render={(props) => <RealizacjaTPay
                                           koszyk={() => this.setState({koszyk: !this.state.koszyk})} {...props}/>}/>
                                <Route exact path="/koszyk/platnosc=error&transakcja=:transakcja"
                                       component={RealizacjaTPayFail}
                                       handler={RealizacjaTPayFail}/>
                                <Route exact path="/konto/bilety/miesieczne/platnosc=ok&transakcja=:transakcja"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNull(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe notify={true}/> : <RealizacjaTPayMiesieczne/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/miesieczne/platnosc=error&transakcja=:transakcja"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNull(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe notify={true}/> :
                                               <RealizacjaTPayFailMiesieczne/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/wynajem" render={() => <Wynajem success={false}/>}
                                       handler={Wynajem}/>
                                <Route exact path="/regulaminy" render={() => <Regulaminy showReg={false}/>}
                                       handler={Regulaminy}/>
                                <Route exact path="/onas" render={() => <FirmaOnas/>}
                                       handler={Regulaminy}/>
                                <Route exact path="/regulaminy/regulamin-przewozow"
                                       render={() => <Regulaminy showReg={true}/>}
                                       handler={Regulaminy}/>
                                <Route exact path="/nagrody" render={() => <Nagrody/>}
                                       handler={Regulaminy}/>
                                <Route exact path="/aktualnosci" component={Aktualnosci} handler={Aktualnosci}/>
                                <Route exact path="/mapa" component={MapaComponent} handler={MapaComponent}/>
                                <Route exact path="/rozklad" component={Rozklad} handler={Rozklad}/>
                                <Route exact path="/faktura" render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                    <GeneratorFaktur/> : <KontoComponent/>}/>
                                <Route exact path="/potwierdzenie-przejazdu" render={() => <PotwierdzeniePrzejazdu/>}/>
                                <Route exact path="/faktura/:idBi" render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                    <GeneratorFaktur {...props}/> : <KontoComponent/>}/>
                                <Route exact path="/zwrot-biletu" component={ZwrotBiletu} handler={ZwrotBiletu}/>
                                <Route exact path="/rozklad/:data/:id/:trasa"
                                       render={(props) => <Rozklad {...props}/>}
                                       handler={Rozklad}/>
                                <Route exact path="/kontakt"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <Redirect to={'/konto/bok/dodaj-zgloszenie'}/> : <Kontakt/>}/>
                                <Route exact path="/aktualnosci/:id/:data"
                                       render={(props) => <Aktualnosci {...props} />}
                                       handler={Aktualnosci}/>
                                <Route exact path="/register" render={() => <RegisterComponent/>}/>
                                <Route exact path="/password-lost" render={() => <PasswordLostComponent/>}/>
                                <Route exact path="/klient/transakcja=:transakcja"
                                       render={(props) => <Transakcja {...props}/>}/>
                                <Route exact path="/strona/:kategoria/:id" render={(props) => <Strona {...props} />}
                                       handler={Strona}/>
                                <Route exact path="/konto/aktywuj/:token"
                                       render={(props) => <Aktywacja {...props}/>}/>
                                <Route exact path="/konto/haslo/reset/:token"
                                       render={(props) => <ResetHasla {...props}/>}/>
                                <Route exact path="/konto/bok"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNullImieNazwisko(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe notify={true}/> : <BOK/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/konto/bok/dodaj-zgloszenie"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNullImieNazwisko(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe/> :
                                               <BOK dodajZgloszenie={true}/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/konto/bok/zgloszenie/:index"
                                       render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <BOKszczegoly {...props}/> : <KontoComponent/>}/>
                                <Route exact path="/konto/eventy"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <Eventy/> : <KontoComponent/>}/>
                                <Route exact path="/konto/eventy/:index"
                                       render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <Event {...props}/> : <KontoComponent/>}/>
                                <Route exact path="/konto/haslo"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <ZmianaHasla/> : <KontoComponent/>}/>


                                           {/*MIESIĘCZNE*/}

                                <Route exact path="/konto/bilety/miesieczne"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           (this.hasNull(JSON.parse(sessionStorage.getItem('loggedIn'))) ? <DaneOsobowe notify={true}/> : <BiletyMiesieczne/>) : <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/miesieczne/success"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           (this.hasNull(JSON.parse(sessionStorage.getItem('loggedIn'))) ? <DaneOsobowe notify={true}/> : <PomyslnieMiesieczny/>) : <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/miesieczne/zamow-bilet"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           (this.hasNull(JSON.parse(sessionStorage.getItem('loggedIn'))) ? <DaneOsobowe notify={true}/> : <BiletyMiesieczne pokazSzczegoly={false} zamowBilet={true}/>) :
                                           <KontoComponent/>}/>

                                            {/*MIESIĘCZNE END*/}


                                <Route exact path="/konto/bilety/jednorazowe"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <BiletyJednorazowe/> : <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/jednorazowe/zglos/:idBi"
                                       render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNullImieNazwisko(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe notify={true} {...props}/> :
                                               <BiletyJednorazowe zglos={true} {...props}/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/jednorazowe/faktura/:idBi"
                                       render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                               <BiletyJednorazowe faktura={true} {...props}/> :
                                           <KontoComponent/>}/>
                                <Route exact path="/konto/bilety/jednorazowe/zglos/:idBi/:idKu/ocena"
                                       render={(props) => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <div> {this.hasNullImieNazwisko(JSON.parse(sessionStorage.getItem('loggedIn'))) ?
                                               <DaneOsobowe {...props}/> :
                                               <BiletyJednorazowe zglos={true} {...props}/>} </div> :
                                           <KontoComponent/>}/>
                                <Route exact path="/login"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <Redirect to={'/konto/dane'}/> : <KontoComponent register={0}/>}/>
                                <Route exact path="/login/zmiana-hasla"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <Redirect to={'/konto'}/> : <KontoComponent zmianaHasla={true}/>}/>
                                <Route exact path="/konto/dane"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <DaneOsobowe/> : <KontoComponent/>}/>
                                <Route exact path="/konto/bilety"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <MojeBilety/> : <KontoComponent/>}/>
                                <Route exact path="/konto"
                                       render={() => (sessionStorage.getItem('loggedIn') !== null) ?
                                           <DaneOsobowe/> : <KontoComponent/>}/>
                                <Route component={Error}/>
                            </Switch>
                        </div>
                    </div>

                    <NotificationContainer/>
                </div>
            </Router>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js